/**
 * TanStack Query hooks for `apptrove-pricing`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from '@tanstack/react-query';
import {
	createQuote,
	listQuotes,
	updateQuoteStatus,
	apptrovePricingQueryKeys,
	type CreateQuoteBody,
	type Quote,
	type QuoteStatus,
} from './api';

export function useApptrovePricingList(): UseQueryResult<Quote[], Error> {
	return useQuery({
		queryKey: apptrovePricingQueryKeys.list(),
		queryFn: listQuotes,
	});
}

export function useApptrovePricingCreate(): UseMutationResult<
	Quote,
	Error,
	CreateQuoteBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createQuote,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apptrovePricingQueryKeys.all });
		},
	});
}

export function useApptrovePricingStatus(): UseMutationResult<
	Quote,
	Error,
	{ id: string; status: QuoteStatus }
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ id, status }) => updateQuoteStatus(id, status),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apptrovePricingQueryKeys.all });
		},
	});
}
